import { FunctionComponent, useEffect } from "react";
import OnlineExam from "../../Components/OnlineExam/OnlineExam";
import "./Exam_participationPracticeReExam.scss";
import { useAppDispatch } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import OnlineExamPractice from "../../Components/OnlineExamPractice/OnlineExamPractice";
import AppBarnav from "../../Components/AppBar/AppBar";
import OnlineExamPracticeReExam from "../../Components/OnlineExamPracticeReExam/OnlineExamPracticeReExam";

interface ExamParticipationPracticeReExamProps {}

const ExamParticipationPracticeReExam: FunctionComponent<
  ExamParticipationPracticeReExamProps
> = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      {" "}
      {/* <AppBarnav /> */}
      <OnlineExamPracticeReExam />
    </>
  );
};

export default ExamParticipationPracticeReExam;
